import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import consultationImage from '@/assets/images/trial_consultation.png';
import { MdCalendarToday, MdClose } from 'react-icons/md';

import { TRIAL_BOOKING_URL } from '@/features/agent/trialConstants';

/** ロック機能クリック時のモーダル */
export default function LockedFeatureModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="w-[658px] max-w-[90vw] overflow-hidden rounded-xl p-0">
        <VisuallyHidden.Root>
          <DialogTitle>製品版のご案内</DialogTitle>
        </VisuallyHidden.Root>

        <div className="relative flex flex-col items-center overflow-hidden p-10">
          {/* 背景装飾 - 上部 */}
          <img
            src="/agent/trial/decorate-top.svg"
            alt=""
            className="pointer-events-none absolute top-0 right-0"
            aria-hidden="true"
          />

          {/* 背景装飾 - 下部 */}
          <img
            src="/agent/trial/decorate-bottom.svg"
            alt=""
            className="pointer-events-none absolute bottom-0 left-0"
            aria-hidden="true"
          />

          {/* 閉じるボタン */}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 z-10 flex size-xxl items-center justify-center rounded-full bg-white hover:opacity-50"
          >
            <MdClose size={24} className="text-placeholder" />
          </button>

          <div className="relative z-[1] flex w-[527px] flex-col items-center justify-center p-lg">
            {/* 見出し */}
            <p
              className="mb-xl text-heading-md"
              style={{
                background: 'linear-gradient(184deg, #ed72f8 0%, #005fff 88%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              この機能は、製品版でお試しいただけます。
            </p>

            {/* イラスト */}
            <img
              src={consultationImage}
              alt="オンライン相談"
              className="mb-xl object-contain"
              width={217}
              height={199}
            />

            {/* 説明文 */}
            <p className="mb-xl w-[427px] text-[13px] leading-[170%]">
              トライアル版をご利用いただきありがとうございます。ご導入後の運用
              イメージや費用対効果について、詳しくご説明いたします。まずは30分
              程度のオンライン相談で、貴社専用の活用イメージをご確認ください。
            </p>

            {/* CTAボタン */}
            <a
              href={TRIAL_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-[55px] w-full max-w-[399px] items-center justify-center gap-xxs rounded-full bg-[#005fff] text-button-lg text-white hover:text-white hover:opacity-90"
            >
              <MdCalendarToday size={20} />
              まずは空き状況をチェック
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
